<template>
<div class="service-content">
  <div class="content">
    <div class="title-name">客户案例</div>
    <div class="title-sub">
      橡诺科技有限公司帮助每一个企业快速实现新型数字化改革
    </div>
    <div class="list">
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-01.jpg"></div>
        <div class="name">银联商务应用市场</div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-02.png"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-03.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-04.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-05.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-06.png"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-07.png"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-08.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-09.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-10.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-11.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-12.png"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-13.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-14.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-15.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-16.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-17.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-18.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-19.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-20.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-21.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-22.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-23.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
      <div class="item">
        <div class="pic"><img src="@/assets/img/case/newanli-24.jpg"></div>
        <div class="name"></div>
        <div class="sub"></div>
      </div>
    </div>
  </div>
  <Mission/>
</div>
</template>

<script>
import Mission from '@/components/Mission'
export default {
  name: '',
  components: {
    Mission
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    overflow: visible;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      overflow: visible;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 18px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        width: 1039px;
        color: #666666;
        transform: .5s;
        line-height: 24px;
        text-align: center;
        font-size: 16px;
        box-sizing: border-box;
      }
      .list{
        // margin-bottom: -20px;
        margin-top: 50px;
        width: 100%;
        display: -webkit-flex;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        box-sizing: border-box;
        .item{
          position: relative;
          width: 380px;
          margin-bottom: 30px;
          overflow: visible;
          display: flex;
          flex-direction: column;
          align-items: center;
          background-color: #FFFFFF;
          cursor: pointer;
          box-sizing: border-box;
          .pic{
            position: relative;
            box-sizing: border-box;
            img{
              width: 100%;
              vertical-align: middle;
            }
            &::before{
              position: absolute;
              content: '';
              top: 0;
              left: 0;
              bottom: 0;
              width: 100%;
              background-color: rgba(0,0,0,.5);
            }
          }
          .name{
            display: none;
            padding: 20px;
            font-weight: 600;
            font-size: 14px;
            text-align: center;
            box-sizing: border-box;
            z-index: 100;
          }
          .sub{
            display: none;
            position: absolute;
            top: 120px;
            left: 0;
            width: 100%;
            color: #fff;
            font-size: 14px;
            padding: 0 20px;
            // display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            box-sizing: border-box;
          }
          &:hover{
            .pic{
              &::before{
                display: none;
              }
            }
          }
        }
        .two-item{
          width: 585px;
          height: 225px;
          .sub{
            width: 450px;
            height: 24px;
          }
        }
      }
    }
}
</style>
